import { ForwardedRef, forwardRef, memo } from 'react';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';

import { CheckboxFieldRoot } from './CheckboxField.styles';

interface SwitchFieldProps extends CheckboxProps {
  disabled?: boolean;
  label?: string;
}

function CheckboxField(props: SwitchFieldProps, ref: ForwardedRef<HTMLButtonElement>) {
  const { disabled: isDisabled, label, color = 'primary' } = props;

  return (
    <CheckboxFieldRoot control={<Checkbox color={color} ref={ref} {...props} />} disabled={isDisabled} label={label} />
  );
}

export default memo(forwardRef(CheckboxField));
